import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import * as S from "./styles";
import { ThemeButton } from "./../../../ThemeButton/styles.js";
import { Grid } from "@material-ui/core";
import { useGlobal } from '../../../../contexts/globalContext';
import RegisterModal from '../../../RegisterModal';

const BusPrice = ({ searchState, selectedDepart, selectedReturn }) => {
	let history = useHistory();
	const [points, setPoints] = useState(0);
	const [cashValue, setCashValue] = useState(0);
	const { signed, user } = useGlobal();
	const [shortenCoinAlias, setShortenCoinAlias] = useState('Pts');

	const [isOpenRegisterModal, setIsOpenRegisterModal] = useState(false);
	const handleRegisterModal = () => setIsOpenRegisterModal((prev) => !prev);

	useEffect(() => {
		setShortenCoinAlias(
			user?.campaign?.campaignConfig?.shortenCoinAlias || 'Pts'
		);
	}, [user?.campaign?.campaignConfig?.shortenCoinAlias]);

	useEffect(() => {
		if (selectedDepart && selectedReturn) {
			let pointsDepart = selectedDepart?.pointsValue || 0;
			let pointsReturn = selectedReturn?.pointsValue || 0;
			setPoints(pointsDepart + pointsReturn);
		} else if (selectedDepart) {
			let pointsDepart = selectedDepart?.pointsValue || 0;
			setPoints(pointsDepart);
		}
	}, [selectedDepart, selectedReturn, searchState]);

	useEffect(() => {
		if (selectedDepart && selectedReturn) {
			let cashDepart = selectedDepart?.cashValue || 0;
			let cashReturn = selectedReturn?.cashValue || 0;
			setCashValue(cashDepart + cashReturn);
		} else if (selectedDepart) {
			let cashDepart = selectedDepart?.cashValue || 0;
			setCashValue(cashDepart);
		}
	}, [selectedDepart, selectedReturn, searchState]);

	const handleSubmit = () => {
		sessionStorage.setItem(
			'@BusSelected',
			JSON.stringify({ ...searchState, selectedDepart, selectedReturn })
		);

		if (user?.guest || user?.travelVoucher) {
			return handleRegisterModal();
		}
		history.push('/busca/resumo');
	};

	return (
		<>
			<S.Wrapper>
				<S.CardContent>
					<Grid container>
						{searchState.idavolta === true ? (
							<>
								<S.GridItemFlex>
									<span className='label-ida-e-volta'>Ida e Volta</span>
								</S.GridItemFlex>
							</>
						) : (
							<>
								<S.GridItemFlex>
									<span className='label-ida'>Ida</span>
								</S.GridItemFlex>
							</>
						)}
						<S.GridItemFlex>
							<span className='total-points'>
								{signed && !user?.guest && user?.campaign?.disablePointActivity ? (
									<span className='points-amount'>
										R$
										{cashValue.toLocaleString('pt-BR', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
										})}
									</span>
								) : (
									<span className='points-amount'>
										{points.toLocaleString('pt-br', {
											minimumFractionDigits: 0,
											maximumFractionDigits: 0,
										})}
										{shortenCoinAlias}
									</span>
								)}
							</span>
						</S.GridItemFlex>
						<S.GridItemFlex>
							<span className='label-total'>Total</span>
						</S.GridItemFlex>
						{/* {searchState.passageiros > 1 ? (
						<>
							<S.GridItemFlex>
								<span className="single-points">
									{singlePoints.toLocaleString("pt-br", {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}{" "}
									Pts
								</span>
							</S.GridItemFlex>
							<S.GridItemFlex>
								<span className="label-points">
									{searchState.passageiros} pessoa{searchState.passageiros > 1 ? "s" : ""}
								</span>
							</S.GridItemFlex>
						</>
					) : (
						<></>
					)} */}
					</Grid>
				</S.CardContent>
				<ThemeButton
					onClick={handleSubmit}
					className='button-select'
					disabled={
						!selectedDepart.key || (searchState.idavolta && !selectedReturn.key)
					}
				>
					Selecionar
				</ThemeButton>
			</S.Wrapper>
			<RegisterModal
				open={isOpenRegisterModal}
				onClose={handleRegisterModal}
				travelVoucherUser={user?.travelVoucher}
			/>
		</>
	);
};

export default BusPrice;
